import { createContext, useContext } from 'react';

const InputTableEditingContext = createContext({
  enableNumberQuickMath: false
});

export function InputTableEditingProvider({ children }: { children: React.ReactNode }) {
  return (
    <InputTableEditingContext.Provider
      value={{
        enableNumberQuickMath: true
      }}
    >
      {children}
    </InputTableEditingContext.Provider>
  );
}

export function useInputTableEditingContext() {
  return useContext(InputTableEditingContext);
}
